module.exports = __webpack_public_path__ + "static/media/0002.62fffae4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/handles/H48011/RAL/0002.png
// module id = 512
// module chunks = 0